import React from "react";
import { MdAdd, MdDelete } from "react-icons/md";

export default function CreateDropDown({
  dropDowns,
  setDropdowns,
}: {
  dropDowns: { heading: string; values: string[] }[];
  setDropdowns: React.Dispatch<
    React.SetStateAction<{ heading: string; values: string[] }[]>
  >;
}) {
  return (
    <div>
      {dropDowns.map((dropdown, index) => (
        <div key={index} className="mb-2">
          <div className="flex flex-col gap-y-2">
            <div className="flex justify-between items-center">
              <label
                htmlFor={`dropdown-heading-${index}`}
                className="text-xs font-semibold "
              >{`QUESTION ${index + 1}`}</label>
              {dropDowns.length > 1 && index === dropDowns.length - 1 && (
                <button
                  onClick={() => {
                    const updated = [...dropDowns];
                    updated.splice(index, 1);
                    setDropdowns(updated);
                  }}
                  className="text-xs text-red-500 underline"
                >
                  Remove
                </button>
              )}
            </div>
            <input
              type="text"
              id={`dropdown-heading-${index}`}
              placeholder="Enter Dropdown Label"
              value={dropdown.heading}
              onChange={(e) => {
                const updated = [...dropDowns];
                updated[index].heading = e.target.value;
                setDropdowns(updated);
              }}
              className="w-full text-[14px] px-4 border border-gray-200 placeholder:text-black text-black rounded-md bg-white py-1.5 focus:outline-none"
            />
          </div>
          <div className=" border-l border-gray-200 pl-4 ml-4">
            {dropdown.values.map((value, vIndex) => (
              <div key={vIndex} className="flex  items-center gap-2 mt-2 ">
                <input
                  type="text"
                  placeholder={`Option ${vIndex + 1}`}
                  value={value}
                  tabIndex={vIndex}
                  onChange={(e) => {
                    const updated = [...dropDowns];
                    updated[index].values[vIndex] = e.target.value;
                    setDropdowns(updated);
                  }}
                  className="w-full text-[14px] px-4 border-b-2 border-gray-200 placeholder:text-black text-black  bg-white py-1.5 focus:outline-none"
                />
                <button
                  onClick={() => {
                    const updated = [...dropDowns];
                    updated[index].values.splice(vIndex, 1);
                    setDropdowns(updated);
                  }}
                  className="p-2 bg-red-500 text-white rounded-md cursor-pointer  disabled:opacity-50"
                >
                  <MdDelete />
                </button>
                {dropDowns[index].values.length - 1 === vIndex && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      const updated = [...dropDowns];
                      updated[index].values.push("");
                      setDropdowns(updated);
                    }}
                    className="p-2 bg-green-500 text-white rounded-md cursor-pointer  disabled:opacity-50"
                  >
                    <MdAdd />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
      <div className="w-full flex justify-end">
        <button
          onClick={() => {
            setDropdowns([...dropDowns, { heading: "", values: [""] }]);
          }}
          type="button"
          className="text-xs ml-auto cursor-pointer underline"
        >
          Add More Qustions
        </button>
      </div>
    </div>
  );
}
